import { render, staticRenderFns } from "./EditFeeDetails.vue?vue&type=template&id=3f4ef634&"
import script from "./EditFeeDetails.vue?vue&type=script&lang=js&"
export * from "./EditFeeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports